import { TalentPoolAttributes } from './talent-pool';
import { OpportunityAttributes } from './opportunity';

export enum CommunityTypes {
  SUBSCRIPTION_REQUESTS = 'subscription_requests',
  SUBSCRIBED = 'subscribed',
  UNSUBSCRIBED = 'unsubscribed',
  INVITED = 'invited',
  ATTENDEES = 'attendees',
  EVENT_VIEWS = 'event_viewers',
  PROFILE_VIEWS = 'profile_viewers',
}
export enum ComunityInvitesOptions {
  INVITE_ATTENDEES = 'invite_attendee',
  INVITE_ALL_ATTENDEES = 'invite_all_attendees',
  INVITE_ALL_EVENT_VIEWERS = 'invite_all_event_viewers',
  INVITE_ALL_PROFILE_VIEWERS = 'invite_all_profile_viewers',
}

export type CommunityApplicationsType =
  | 'subscription_requests'
  | 'subscribed'
  | 'unsubscribed'
  | 'invited'
  | 'attendees';

export type CommunityBoardType =
  | 'event_views'
  | 'profile_views'
  | 'attendees'
  | 'subscribed';

export interface CommunityDashboardAttributes {
  event_views: number;
  profile_views: number;
  invited_count: number;
  attendees_count: number;
  saved_count: number;
  subscribers_count: number;
  subscription_requests_count: number;
}

export interface ExtendedCandidateAttributes extends TalentPoolAttributes {
  event_registrations_count: number;
  invited: boolean;
}

export interface CommunityCandidate {
  id: string;
  type: string;
  attributes: ExtendedCandidateAttributes;
}

export interface CommunityCandidateResponse {
  data: CommunityCandidate;
}

export interface CommunityCandidateAttributes {
  accepted_invitation: boolean | null;
  approved: boolean;
  candidate: CommunityCandidateResponse;
  created_at: string;
  email: string;
  first_name: string | null;
  id: string;
  last_name: string | null;
  subscribed_email: boolean;
  updated_at: string;
}

export interface CommunityResponse {
  id: string;
  type: string;
  attributes: CommunityCandidateAttributes;
}

export interface CommunityPaginationResponse {
  data: Array<CommunityResponse>;
  meta: {
    total: number;
  };
}

export interface CandidatePaginationResponse {
  data: Array<CommunityCandidate>;
  meta: {
    total: number;
  };
}

export interface CommunityAttributes extends ExtendedCandidateAttributes {
  accepted_invitation: boolean | null;
  approved: boolean;
  created_at: string;
  subscribed_email: boolean;
  candidate_id: string;
  updated_at: string;
}

type ApplicationsAvatar = {
  avatar_url: string | null;
  email: string;
  name: string;
};
export interface CommunityEventAttributes extends OpportunityAttributes {
  registered_applications_avatar: ApplicationsAvatar[];
}

export interface CommunityEvent {
  id: string;
  type: 'touchpoint';
  attributes: CommunityEventAttributes;
}

export interface CommunityEventResponse {
  data: CommunityEvent[];
  meta: {
    total: number;
  };
}
